import useWishlist from "api/wishlistResource/useWishlist";
import { BookListItem, CustomPaginator } from "components";
import AccountPage from "../AccountPage";
import AccountLayout, { AccountSkeleton } from "../AccountLayout";
import useProfile from "api/UserResource/useProfile";
import { useState } from "react";
import { FiHeart, FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const Wishlist = () => {
	const [page, setPage] = useState(1);
	const [firstPage, setFirstPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(40);
	const { data: profile, isLoading } = useProfile();
	const {
		data,
		isLoading: loadingWishlist,
		isError,
		refetch,
	} = useWishlist({ page, rows_per_page: rowsPerPage });
	const books = data?.data?.records ?? [];
	const totalRecords = data?.data?.total_records ?? 0;
	const totalPages = data?.data?.total_pages ?? 1;
	return (
		<AccountPage>
			<AccountLayout isLoading={isLoading} profile={profile?.data}>
				{loadingWishlist ? (
					<AccountSkeleton />
				) : isError ? (
					<div className="account-empty" role="alert">
						<FiHeart aria-hidden="true" />
						<h2>Your wishlist couldn’t be loaded</h2>
						<p>Please try again in a moment.</p>
						<button type="button" className="account-button" onClick={() => refetch()}>
							Try again
						</button>
					</div>
				) : !books.length ? (
					<div className="account-empty">
						<FiHeart aria-hidden="true" />
						<h2>A place for your must-reads</h2>
						<p>Find something you love? Add it to your wishlist and come back to it anytime.</p>
						<Link to="/books" className="account-button">
							Discover books <FiArrowRight aria-hidden="true" />
						</Link>
					</div>
				) : (
					<>
						<div className="account-section-heading">
							<h2>
								{totalRecords} {totalRecords === 1 ? "book" : "books"} on your wishlist
							</h2>
							<p>Use the heart on a book to remove it from your saved reads.</p>
						</div>
						<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
							{books.map((book) => (
								<BookListItem
									key={book.id}
									bookId={book.id}
									coverUrl={book?.book_cover?.url}
									title={book?.title}
									author={book?.author}
									price={book?.price}
									zwl_price={book?.zwl_price} prices={book?.prices}
									rating={book?.rating}
									sellable={book?.sellable}
									isFree={book?.isFree}
									format={book?.format}
									showWishlist
									isInWishlist
								/>
							))}
						</div>
						{totalPages > 1 && (
							<div className="mt-8 pt-6 border-t">
								<CustomPaginator
									firstPage={firstPage}
									setFirstPage={setFirstPage}
									rowsPerPage={rowsPerPage}
									setRowsPerPage={setRowsPerPage}
									totalRecords={totalRecords}
									setPage={setPage}
									showRowsPerPageDropdown={false}
								/>
							</div>
						)}
					</>
				)}
			</AccountLayout>
		</AccountPage>
	);
};
export default Wishlist;
